import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = { class: "consent-detail" }
const _hoisted_4 = { class: "consent-detail" }

import { computed, ref, watch, toRefs } from "vue";
import Checkbox from "@/components/inputs/Checkbox.vue";
import { ConsentServiceEntityTypeIds, ConsentTypeIds } from "@/types/consents";
import type { ConsentFormVM } from "@/types/consents";
import type { FieldSchema, FormSchema } from "@/models/form";
import useConsents from "@/composables/consents/consentsHelpers";
import { useApplicationStore } from "@/store/store/applicationVMStore";
import { FormModes } from "@/types/form";


export default /*@__PURE__*/_defineComponent({
  __name: 'ParentAttestationConsent',
  props: {
    disabled: { type: Boolean, default: false },
    modelValue: { type: Boolean, default: undefined },
    entityTypeId: {},
    entityId: {},
    details: {},
    mode: {},
    required: { type: Boolean, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const checkboxRef = ref<InstanceType<typeof Checkbox>>();

const applicationStore = useApplicationStore();

const props = __props;

const emit = __emit;

const { entityId } = toRefs(props);
const parentConsent = ref<boolean | undefined>(undefined);
const parentConsentId = ref<number>();

const errors = computed<Record<string, string>>(
  () => checkboxRef.value?.errors || {}
);

const schema = ref<FormSchema>({
  parentConsent: {
    name: "parentConsent",
    type: "checkbox",
    label:
      "By checking this box, you affirm that you are the student's parent or legal guardian and that you claim the student as a dependent on your tax return.",
    errorMessage: "You must check the box to continue.",
    required: true,
    validate: (schema: FieldSchema) => {
      if (!props.required) {
        schema.valid = true;
        schema.errors = [];
        return;
      }
      schema.valid = !errors.value.parentConsent;
      schema.errors = errors.value.parentConsent
        ? [errors.value.parentConsent]
        : [];

      if (!schema.valid) {
        schema.touched = true;
      } else {
        schema.valid = undefined;
        schema.errors = [];
      }
    },
  } as FieldSchema,
} as FormSchema);

const { addParentAttestationConsentAsync } = useConsents(entityId);

function handleChange(consentGiven: undefined | boolean) {
  emit("update:modelValue", consentGiven);
}

async function getParentAttestationConsents() {
  const parentConsentTypeId = ConsentTypeIds.PARENT_ATTESTATION;

  parentConsentId.value = parentConsentTypeId;

  const parentAttestationConsent =
    applicationStore?.application?.tabApplicationViewModel?.student
      ?.parentAttestation;

  if (parentAttestationConsent) {
    parentConsent.value = parentAttestationConsent?.consentGiven;
    parentConsentId.value = parentAttestationConsent?.id;
    emit("update:modelValue", parentAttestationConsent?.consentGiven);
  } else {
    emit("update:modelValue", undefined);
  }
}

watch(
  () => props.modelValue,
  () => {
    parentConsent.value = props.modelValue;
  },
  {
    immediate: true,
  }
);

__expose({
  addParentAttestationConsentAsync,
  errors,
  getParentAttestationConsents,
  parentConsent,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Checkbox, {
      ref_key: "checkboxRef",
      ref: checkboxRef,
      name: schema.value.parentConsent.name || 'parentConsent',
      modelValue: parentConsent.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((parentConsent).value = $event)),
      schema: schema.value.parentConsent,
      disabled: __props.disabled,
      onChange: _cache[1] || (_cache[1] = ($event: any) => (handleChange(parentConsent.value)))
    }, {
      label: _withCtx(() => [
        _createTextVNode(_toDisplayString(schema.value.parentConsent.label), 1)
      ]),
      _: 1
    }, 8, ["name", "modelValue", "schema", "disabled"]),
    (
        __props.entityTypeId === _unref(ConsentServiceEntityTypeIds).Draw &&
        __props.mode !== _unref(FormModes).add
      )
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "consent-details",
          disabled: __props.disabled
        }, [
          _createElementVNode("div", _hoisted_3, [
            _cache[2] || (_cache[2] = _createElementVNode("span", null, "Consented by: ", -1)),
            _createTextVNode(_toDisplayString(__props.details?.personName || __props.details?.consentedBy || "N/A"), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _cache[3] || (_cache[3] = _createElementVNode("span", null, "Consented at: ", -1)),
            _createTextVNode(_toDisplayString(__props.details?.createdAtDisplay || "N/A"), 1)
          ])
        ], 8, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}
}

})